import { ChevronRight } from "lucide-react";
import React from "react";
import { cardTypeConfig } from "@/pages/Home/card/view/_components/cardTypeConfig";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { CreditCard, CreditCardTypes } from "@/api/credit-cards/credit-cards";
import { cn } from "@/lib/utils";

type PaymentCardVariant = VariantProps<typeof paymentCardVariants>;

type Props = {
	card: CreditCard;
	shouldDisplayChevron?: boolean;
	variant?: PaymentCardVariant["border"];
};

const PaymentCard: React.FC<Props> = ({
	card,
	shouldDisplayChevron = false,
	variant = "default",
}) => {
	const Icon = cardTypeConfig[card.card_type].Icon;

	const capitalizedCardNames: CreditCardTypes[] = ["DISCOVER", "MASTERCARD"];

	return (
		<div className={paymentCardVariants({ border: variant })}>
			<div className="flex items-center justify-between w-full gap-3">
				<div className="flex items-center  gap-3 w-full">
					<div className="flex items-center justify-center">
						<Icon className="h-4 w-4 text-neutral-400" variant="dark" />
					</div>
					<div>
						<p className="text-sm font-bold text-textDark text-left">
							{card.card_holder}
						</p>
						<p
							className={cn("text-sm  font-medium text-textLight uppercase", {
								"lowercase first-letter:capitalize":
									capitalizedCardNames.includes(card.card_type),
							})}
						>
							{card.card_type} {card.last4}
						</p>
					</div>
				</div>
				{shouldDisplayChevron && (
					<ChevronRight className="w-5 h-5 text-textLight" />
				)}
			</div>
		</div>
	);
};

export default PaymentCard;

// Set up a basic CVA class for PaymentCard
export const paymentCardVariants = cva(
	"flex items-center justify-between text-left p-4 bg-white w-full rounded-3xl [&_svg]:size-10",
	{
		variants: {
			border: {
				default: "border border-gray-200",
				borderless: "border-0",
			},
		},
		defaultVariants: {
			border: "default",
		},
	},
);
